import { CONTACTS_PER_COMPANY_DEFAULT_PLACEHOLDER } from "app/pages/sales-intelligence/common-components/contacts-per-company-limit-input/constants";
import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";

import ContactLimitResultsFilter from "../../components/filters/ContactLimitResultsFilter/ContactLimitResultsFilter";
import ContactLimitResultsFilterResult from "../../components/filters/ContactLimitResultsFilter/ContactLimitResultsFilterResult";
import { contactsFilterCategoryMap } from "../../types/contactsFilterCategory";

import FindContactLimitResultsFilter from "./ContactLimitResultsFilter";

const createContactLimitResultsFilter = (): SearchFilterInstance => {
    return {
        key: "contactsPerCompanyFilter",
        trackingName: "Contacts per Company",
        apiCategory: "contactsFilters",
        title: { key: "si.lead_gen_filters.category.contacts_per_company_filter.name" },
        tooltipText: { key: "si.lead_gen_filters.category.contacts_per_company_filter.tooltip" },
        filter: new FindContactLimitResultsFilter({ options: CONTACTS_PER_COMPANY_DEFAULT_PLACEHOLDER }),
        filterView: ContactLimitResultsFilter,
        filterResultView: ContactLimitResultsFilterResult,
        category: contactsFilterCategoryMap.contacts,
    };
};

export default createContactLimitResultsFilter;
